var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main tableloading"},[_c('breadcrumb',{staticClass:"breadcrumb-container"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('div',{staticClass:"boxContainer"},[_c('router-view',{key:_vm.key})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf8904d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/AppMain.vue
// module id = null
// module chunks = 